module.exports = __webpack_public_path__ + "price-history.svg?97724c81f95ecbdce0f971c48238d7ea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-history.svg
// module id = 308
// module chunks = 2